var map = {
	"./van-checkbox-group.js": "b783",
	"./van-field.js": "d6ac",
	"./van-radio-group.js": "a1ba",
	"./van-rate.js": "e467",
	"./vc-calendar.js": "0616",
	"./vc-datetime.js": "b45a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1330";